import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Domain redirect — redirect alias domains to primary
const PRIMARY_DOMAIN = 'iamnatashasimone.com';
const REDIRECT_DOMAINS = [
  'yellowmangoproduction.com',
  'www.yellowmangoproduction.com',
  'yellowmangomediagroup.com',
  'www.yellowmangomediagroup.com',
  'asknatashasimone.com',
  'www.asknatashasimone.com',
  'shakeopenandpour.com',
  'www.shakeopenandpour.com',
  'diverseintelligencesystems.com',
  'www.diverseintelligencesystems.com',
  'salonspaeducationalwellness.com',
  'www.salonspaeducationalwellness.com',
];

const currentHost = window.location.hostname;
if (REDIRECT_DOMAINS.includes(currentHost)) {
  window.location.replace(`https://${PRIMARY_DOMAIN}${window.location.pathname}${window.location.search}`);
} else {

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

}
